<template>
  <div class="container" id="EventUpload">
    <el-form class="wrap" :rules="rules" ref="ruleForm" :model="formData">
      <div class="title">
        <div class="return" @click="returnEventFlow">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="titleText">
          <i class="el-icon-location"></i>
          事件流转-上传事件
        </div>
      </div>
      <div class="content">
        <el-form-item label="污染类型：" prop="pollutValue" class="contentItem">
          <!-- <div class="label">污染类型：</div> -->
          <div class="input">
            <el-cascader
              clearable
              v-model="formData.pollutValue"
              :options="pollutOptions"
              :props="{
                expandTrigger: 'hover',
                multiple: true,
                checkStrictly: true,
              }"
            ></el-cascader>
          </div>
        </el-form-item>
        <el-form-item label="事件类型：" prop="eventType" class="contentItem">
          <div class="label"></div>
          <div class="input">
            <el-select
              v-model="formData.eventType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in eventOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="上传工地："
          prop="location.address"
          class="contentItem"
        >
          <div class="input">
            <el-select
              filterable
              v-model="formData.location.address"
              clearable
              placeholder="请填写上传工地"
              @change="chooseLocation"
            >
              <el-option
                v-for="item in locationData"
                :key="item.value"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="hasIcons" @click="mapVisible = true">
            <img src="../../assets/img/event/location.png" alt />
          </div>
          <!-- <div class="hasIcons" @click="locationListVisible = true">
            <img src="../../assets/img/event/list.png" alt />
          </div>-->
        </el-form-item>
        <el-form-item label="文字描述：" prop="detail" class="contentItem">
          <!-- <div class="label">文字描述：</div> -->
          <div class="textarea">
            <el-input
              type="textarea"
              maxlength="199"
              show-word-limit
              :rows="3"
              placeholder="请填写内容详情，方便了解"
              v-model="formData.detail"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="图片上传：" prop="fileList" class="contentItem">
          <!-- <div class="label">图片上传：</div> -->
          <div class="uploadinput">
            <el-upload
              action="#"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :auto-upload="false"
              :on-change="handleImageChange"
              :limit="9"
              :file-list="fileList"
            >
              <i class="el-icon-plus" v-show="fileList.length < 9"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <div class="limit">(最多上传9张)</div>
          </div>
        </el-form-item>
        <el-form-item label="视频上传：" prop="video" class="videoItem">
          <el-upload
            action="#"
            :auto-upload="false"
            :on-change="beforeUploadVideo"
            :limit="limit"
            :on-exceed="handleExceed"
            :on-remove="handleVideoRemove"
            :file-list="videoList"
            :disabled="uploadVideo"
          >
            <el-button
              :disabled="uploadVideo"
              size="small"
              type="primary"
              :loading="uploadVideo"
              >{{ uploadVideo ? "上传中..." : "点击上传" }}</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传视频文件，且不超过50M
            </div>
            <!-- <i v-else-if="formData.video == ''" class="el-icon-plus"></i> -->
            <!-- <i class="el-icon-plus" v-show="videoList.length < 1"></i> -->
          </el-upload>
        </el-form-item>
        <template v-if="formData.video.length > 0">
          <video
            v-for="(item, index) in formData.video"
            :key="index"
            :src="item.url"
            class="videos"
            controls="controls"
          >
            您的浏览器不支持视频播放
          </video>
        </template>

        <el-form-item label="转办：" prop="toWhom" class="contentItem">
          <!-- <div class="label">转办：</div> -->
          <div class="input">
            <el-select v-model="formData.toWhom" clearable placeholder="请选择">
              <el-option
                v-for="item in transOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      <div class="btns">
        <div class="reset" @click="reset">重置</div>
        <div class="toupload" @click="submitForm">立即提交</div>
      </div>
    </el-form>
    <!-- <list-popup
      :options="locationData"
      @selectedLocation="selectedLocation"
      :locationListVisible="locationListVisible"
      @dialog-cancel="locationListVisible=false"
    ></list-popup>-->
    <!-- 上传完成弹框 -->
    <el-dialog
      class="doneDialog"
      :show-close="false"
      :visible.sync="uploadVisible"
      width="20%"
    >
      <img src="../../assets/img/event/uploadSuccess.png" alt />
      <div class="success">上传成功</div>
      <div class="toSee" @click="toList">立即查看</div>
      <div class="toContinue" @click="doReset">继续上传</div>
    </el-dialog>
    <!-- 上传地点弹框 -->
    <el-dialog
      class="mapDialog"
      :show-close="false"
      :visible.sync="mapVisible"
      width="50%"
    >
      <div id="dialogMap" class="map"></div>
      <div class="mapInput">
        <div class="mapLabel">上传工地：</div>
        <el-select
          class="mapSelect"
          filterable
          v-model="mapLocation"
          clearable
          placeholder="请填写上传工地"
          @change="mapSelectChange"
        >
          <el-option
            v-for="item in locationData"
            :key="item.value"
            :label="item.label"
            :value="item"
          ></el-option>
        </el-select>
        <div class="overallCircleClose" @click="mapVisible = false">
          <img src="../../assets/img/event/close.png" alt />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mapVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import ListPopup from "@/components/common/popups/ListPopup";
import { getServerData } from "@/utils/fetchData";
import { APIMAP } from "@/constants/apiConstants";
import { mapState } from "vuex";

export default {
  name: "EventUpload",
  // components: {
  //   ListPopup,
  // },
  data() {
    return {
      uploadVideo: false, // 上传视频标识
      debounceFlag: true,
      marker: null,
      // 自定义的 没办法 只能用中文了 懒
      mapDetailList: [
        { name: "污染类型", key: null, type: "pollutValue" },
        { name: "事件类型", key: null, type: "eventType" },
        { name: "上传工地", key: null, type: "location" },
        { name: "文字描述", key: null, type: "detail" },
        { name: "图片上传", key: null, type: "filelist" },
        { name: "视频上传", key: null, type: "video" },
        { name: "转办", key: null, type: "toWhom" },
      ],
      rules: {
        pollutValue: [
          { required: true, message: "请选择污染类型", trigger: "blur" },
        ],
        "location.address": [
          { required: true, message: "请填写上传地点", trigger: "blur" },
        ],
        eventType: [
          { required: true, message: "请选择事件类型", trigger: "blur" },
        ],
        detail: [
          { required: true, message: "请填写文字描述", trigger: "blur" },
        ],
        fileList: [
          {
            required: true,
            message: "请上传",
            validator: (rule, value, cb) => {
              if (this.fileList.length) {
                cb();
              } else {
                cb(new Error("请上传"));
              }
            },
          },
        ],
      },
      detailList: [], // 上传的标签列表
      map: null,
      mkn: null,
      pollutOptions: [],
      eventOptions: [],
      locationData: [],
      transOptions: [],
      LocalCityName: "",
      contentList: [],
      fileList: [],
      videoList: [],
      tablename: "",
      mapLocation: "",
      formData: {
        pollutValue: "",
        location: {
          address: "",
          longitude: "",
          latitude: "",
          street: "",
        },
        eventType: "", // 事件类型
        detail: "",
        toWhom: "",
        video: [],
      },
      mapText: "",
      searchedLocation: "",
      // 控制图片预览弹框
      dialogImageUrl: "",
      dialogVisible: false,
      mapVisible: false,
      uploadVisible: false,
      // 工地列表弹框
      locationListVisible: false,
      mapType: {
        1: "(一般类问题)",
        2: "(严重类问题)",
        3: "(特别严重问题)",
      },
      isEdit: false, //是否是编辑
      limit: 5,
    };
  },
  watch: {
    mapVisible(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (newValue) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },
  },
  mounted() {
    console.log(this.userInfo, this.$route.query.gid);
    if (this.$route.query.gid != null && this.master.gid != null) {
      this.isEdit = true;
    }
    this.initDetail();
  },
  computed: {
    ...mapState({
      eid: (state) => state.userInfo.eid,
      pid: (state) => state.userInfo.platformid,
      dept: (state) => state.userInfo.dept,
      gid: (state) => state.userInfo.gid,
      uname: (state) => state.userInfo.realname,
      master: (state) => state.Event.master,
    }),
  },
  methods: {
    async initDetail() {
      try {
        console.log(this.userInfo);
        const res = await getServerData(
          `${APIMAP.GET_EVENTFLOW_INPUTS}${this.eid}`,
          {
            eid: this.eid,
          }
        );
        console.log(res);
        const { detail, tablename } = res;
        this.tablename = tablename;
        this.detailList = JSON.parse(detail);

        console.log("detail", JSON.parse(detail));
        const dataParam1 = { pid: this.pid };
        const dataParam2 = { pid: this.pid };
        const dataParam3 = { pid: this.pid };
        const dataParam4 = { pid: this.pid };
        // key是上传时的那个key
        this.mapDetailList.forEach((item) => {
          const temp = this.detailList.find(
            (detailItem) => item.name === detailItem.name
          );
          console.log(item, temp);
          const { formName } = temp;
          if (item.name == "污染类型") {
            dataParam1.gid = temp.zid;
          } else if (item.name == "事件类型") {
            dataParam2.gid = temp.zid;
          } else if (item.name == "转办") {
            dataParam3.eid = 2;
          } else if (item.name == "上传工地") {
            dataParam4.gid = temp.zid;
            dataParam4.mini = 1;
          }
          // 获取到每个上传字段的 字段名
          item.key = formName;
          // if (type === "select" && temp.multi && temp.multi == 2) {
          //   // 双重下拉框
          //   item.key = formName.split(",")[0];
          //   item.doubleKey = formName.split(",")[1];
          // }
          // console.log("object");
          // console.log(temp, item, index);
        });
        Promise.all([
          getServerData(APIMAP.GET_RESOURCE_TYPE, dataParam1),
          getServerData(APIMAP.GET_RESOURCE_TYPE, dataParam2),
          getServerData(APIMAP.GET_DEPARTMENT, dataParam3),
          getServerData(APIMAP.GET_RESOURCE_TYPE, dataParam4),
        ]).then((res) => {
          // res[0] => 污染类型 res[1] => 事件类型 res[2] => 转办 res[3] => 上传地点
          this.pollutOptions =
            res[0] &&
            res[0].data.map((item) => {
              const temp = {};
              temp.value = item.name;
              temp.label = item.name;
              temp.children = item.sub.map((it) => {
                return {
                  value: it.name + "|" + it.type,
                  label: it.name + this.mapType[+it.type],
                  level: it.type,
                };
              });
              return temp;
            });
          this.eventOptions =
            res[1] &&
            res[1].data.map((item) => {
              return {
                label: item.name,
                value: item.name,
              };
            });
          this.transOptions =
            res[2] &&
            res[2].map((item) => {
              return {
                label: item.name,
                value: item.name,
              };
            });

          this.locationData =
            res[3] &&
            res[3].data.map((item) => {
              return {
                ...item,
                label: item.name,
                value: item.name,
              };
            });
          console.log(res);
          if (this.isEdit) {
            //
            this.mapDetailList.forEach((it) => {
              if (it.type == "location") {
                this.formData.location.address = this.master["address"];
                this.formData.location.longitude = this.master["longitude"];
                this.formData.location.latitude = this.master["latitude"];
                this.formData.location.street = this.master["street"];
              } else if (it.type == "filelist") {
                // 图片
                this.fileList = this.master[it.key].map((img, i) => ({
                  url: img,
                  uid: +new Date() + i,
                  myurl: img,
                }));
              } else if (it.type == "pollutValue") {
                const temp = JSON.parse(this.master[it.key]);
                this.formData[it.type] = temp.map((putype) => {
                  return [putype.ptype, putype.ctype + "|" + putype.level];
                });
                console.log(temp, "污染类型");
              } else if (it.type == "video") {
                this.formData[it.type] = this.master[it.key];
              } else {
                this.formData[it.type] = this.master[it.key];
              }
            });
            console.log(
              this.master,
              "this.master",
              this.mapDetailList,
              this.formData,
              this.detailList
            );
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    initMap() {
      const BMap = window.BMap;
      if (!this.map) {
        this.map = new window.BMap.Map("dialogMap");
      }
      // this.map.addEventListener("dragend", () => {
      //   var pixel = this.map.pointToOverlayPixel(this.map.getCenter());
      //   var Point = this.map.overlayPixelToPoint({
      //     x: pixel.x,
      //     y: pixel.y
      //   });
      //   console.log(pixel);
      //   this.mkn && this.map.clearOverlays(this.mkn);
      //   this.mkn = new BMap.Marker(Point);
      //   this.map.addOverlay(this.mkn);
      // });
      if (!this.LocalCityName) {
        var myCity = new BMap.LocalCity();
        myCity.get((result) => {
          var cityName = result.name;
          this.map.setCenter(cityName);
          console.log("当前城市", cityName);
          this.LocalCityName = cityName;
          this.map.centerAndZoom(this.LocalCityName, 12);
          this.map.enableScrollWheelZoom(true);
        });
      }
    },
    returnEventFlow() {
      this.$confirm("当前内容尚未保存，确定返回?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$nv("/eventFlow");
        })
        .catch(() => {
          // do nothing
        });
    },
    async beforeUploadVideo(file, fileList) {
      console.log(file, fileList);
      const isLt50M = file.size / 1024 / 1024 <= 50;
      if (
        [
          "video/mpeg4",
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/quicktime",
        ].indexOf(file.raw.type) == -1
      ) {
        this.videoList = [];
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt50M) {
        this.videoList = [];
        this.$message.error("上传视频大小不能超过20MB哦!");
        return false;
      }

      // 到这里是成功了
      try {
        this.uploadVideo = true;
        const res = await getServerData(
          APIMAP.UPLOAD,
          {
            file: file.raw,
            pid: this.pid,
            type: "2",
          },
          "post",
          0,
          true
        );
        const { url } = res;
        console.log(url);
        const urlItem = {};
        urlItem.uid = file.uid;
        urlItem.url = url;
        this.formData.video.push(urlItem);
        this.uploadVideo = false;
      } catch (e) {
        this.uploadVideo = false;
        console.log(e);
      }
    },
    handleExceed(file) {
      console.log("exceed", file);
      this.$message.error(
        `视频上传失败，最多不能超过${this.limit}个，请先删除！`
      );
    },
    handleVideoRemove(file) {
      console.log("remove", file, this.videoList);
      this.formData.video = this.formData.video.filter(
        (item) => item.uid !== file.uid
      );
    },
    handleVideoCardPreview(file) {
      console.log(file);
    },
    handleVideoSuccess(res, file) {
      console.log(res, file, "去上传");
      //获取上传图片地址
      // if (res.status == 200) {
      //   this.video = res.data.uploadUrl;
      // } else {
      //   this.$message.error("视频上传失败，请重新上传！");
      // }
    },
    // handleVideoChange(file, fileList) {
    //   console.log(file, fileList);
    // },
    // 文件上传
    handleRemove(file) {
      console.log("remove", file, this.fileList);
      this.fileList = this.fileList.filter((it) => it.myurl !== file.myurl);
      console.log("delted", this.fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // handleChange(e) {
    //   console.log(e, this.formData.pollutValue);
    // },
    submitForm() {
      if (this.uploadVideo) {
        this.$message({
          type: "warning",
          message: "请先等待视频上传完成",
        });
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        console.log(this.formData);
        if (valid && this.debounceFlag) {
          this.debounceFlag = false;
          // 通过
          console.log(this.formData, this.fileList, this.mapDetailList);
          const params = {};
          const arr = [];
          this.mapDetailList.forEach((item) => {
            console.log(item, "means");
            if (this.formData[item.type]) {
              // 污染类型
              if (
                Array.isArray(this.formData[item.type]) &&
                item.type !== "video"
              ) {
                // params[item.key] = this.formData[item.type][0];
                // params[item.doubleKey] = this.formData[item.type][1];
                params[item.key] = JSON.stringify(
                  this.formData[item.type].map((it) => ({
                    ptype: it[0],
                    ctype: it[1].split("|")[0],
                    level: +it[1].split("|")[1],
                  }))
                );
                arr.push(item.key);
              } else if (item.type == "location") {
                params.address = this.formData[item.type].address;
                params.longitude = this.formData[item.type].longitude;
                params.latitude = this.formData[item.type].latitude;
                params.street = this.formData[item.type].street;
                arr.push("address");
                arr.push("longitude");
                arr.push("latitude");
                arr.push("street");
              } else {
                arr.push(item.key);
                params[item.key] = this.formData[item.type];
              }
            }
            if (item.type == "filelist" && this.fileList.length) {
              arr.push(item.key);
              params[item.key] = this.fileList.map((it) => it.myurl).join("|");
            }
            // this is
            if (item.type === "video" && this.formData.video.length) {
              params[item.key] = this.formData.video
                .map((it) => it.url)
                .join("|");
            }
            if (item.type == "toWhom" && this.formData[item.type]) {
              params["receivedept"] = this.formData[item.type];
            }
          });
          if (this.isEdit) {
            try {
              const res = await getServerData(
                APIMAP.EVENT,
                {
                  columns: arr.join(","),
                  ...params,
                  dept: this.dept,
                  mid: this.eid,
                  uid: this.gid,
                  uname: this.uname,
                  table: this.tablename,
                  receivedept: this.master["receivedept"],
                  receiveid: this.master["receiveid"],
                  operational: "重新上传",
                  status: "0",
                  eid: this.master["mid"],
                  gid: this.master["gid"],
                },
                "put"
              );
              console.log(res);
              this.uploadVisible = true;
              this.debounceFlag = true;
            } catch (e) {
              console.log(e);
              this.debounceFlag = true;
            }
          } else {
            try {
              console.log(
                {
                  columns: arr.join(","),
                  ...params,
                  dept: this.dept,
                  mid: this.eid,
                  uid: this.gid,
                  uname: this.uname,
                  table: this.tablename,
                },
                "sadasdahgsidghsa"
              );
              const res = await getServerData(
                APIMAP.EVENT,
                {
                  columns: arr.join(","),
                  ...params,
                  dept: this.dept,
                  mid: this.eid,
                  uid: this.gid,
                  uname: this.uname,
                  table: this.tablename,
                },
                "post"
              );
              console.log(res);
              this.uploadVisible = true;
              this.debounceFlag = true;
            } catch (e) {
              console.log(e);
              this.debounceFlag = true;
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async handleImageChange(file, filelist) {
      console.log(file, filelist, "sgsegs");
      if (filelist.length === 0) return;
      if (
        ["image/jpeg", "image/jpg", "image/png"].indexOf(file.raw.type) == -1
      ) {
        this.fileList = [];
        this.$message.error("请上传正确的图片格式");
        return false;
      }
      try {
        const res = await getServerData(
          APIMAP.UPLOAD,
          {
            file: file.raw,
            pid: this.pid,
            type: "1",
          },
          "post",
          0,
          true
        );
        const { url } = res;
        this.fileList = [...this.fileList, { ...file, myurl: url }];
      } catch (e) {
        console.log(e);
      }
    },
    reset() {
      this.$confirm("确认重置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.doReset();
          this.$message({
            type: "success",
            message: "重置成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    chooseLocation(e) {
      this.formData.location.longitude = e.longitude;
      this.formData.location.latitude = e.latitude;
      this.formData.location.address = e.value;
      this.formData.location.street = e.street;
    },
    mapSelectChange(e) {
      const { latitude, longitude, value } = e;
      const BMap = window.BMap;
      if (!this.map) return;
      this.marker && this.map.clearOverlays(this.marker);
      const point = new BMap.Point(longitude, latitude);
      this.marker = new BMap.Marker(point);
      this.map.addOverlay(this.marker);
      this.map.centerAndZoom(point, 15);
      this.formData.location.longitude = longitude;
      this.formData.location.latitude = latitude;
      this.formData.location.address = value;
    },
    toList() {
      this.$nv("/eventFlow", { tab: "流转中" });
    },
    doReset() {
      this.uploadVisible = false;
      this.formData = {
        pollutValue: "",
        location: {
          address: "",
          longitude: "",
          latitude: "",
        },
        eventType: "", // 事件类型
        detail: "",
        toWhom: "",
      };
      this.fileList = [];
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  box-sizing: border-box;
  padding: 24px 26px;
  width: 100%;
  .wrap {
    background: #fff;
    min-height: 850px;
    font-size: 16px;
    color: #99a9ba;
    padding: 24px 27px;
    box-sizing: border-box;

    .title {
      display: flex;
      border-bottom: 1px solid #e2e5ec;
      padding-bottom: 18px;
      .return {
        cursor: pointer;
      }
      .titleText {
        margin-left: 23px;
      }
    }
    .content {
      margin-top: 30px;
      border-bottom: 1px solid #e2e5ec;

      .contentItem {
        display: flex;
        margin-bottom: 24px;

        .input {
          width: 385px;
        }
        .touploadinput {
          width: 800px;
          .limit {
            color: #838997;
            font-size: 15px;
            margin: 4px 0;
          }
        }
        .hasIcons {
          img {
            cursor: pointer;
            width: 40px;
            margin: 0 0 0 10px;
          }
        }
        .textarea {
          width: 90%;
        }
      }
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    div {
      width: 150px;
      height: 42px;
      line-height: 42px;
      font-size: 15px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
    .reset {
      border: 1px solid rgba(201, 209, 212, 0.7);
      margin-right: 16px;
    }
    .toupload {
      background: var(--themeColor);
      color: #fff;
    }
  }

  .map {
    width: 100%;
    height: 425px;
  }
  .mapDialog {
    .mapInput {
      display: flex;
      padding: 18px 26px;
      box-sizing: border-box;
      .mapLabel {
        width: 80px;
        line-height: 40px;
      }
      .mapSelect {
        width: 100%;
      }
    }
  }
  .doneDialog {
    text-align: center;

    img {
      margin: 46px 0 12px 0;
    }
    .success {
      font-size: 24px;
      color: #2c3a50;
    }
    .toSee {
      background: #009157;
      border-radius: 5px;
      width: 164px;
      margin: 39px auto 13px auto;
      cursor: pointer;
      color: #fff;
      height: 36px;
      line-height: 36px;
    }
    .toContinue {
      font-size: 15px;
      color: #838997;
      padding-bottom: 28px;
      cursor: pointer;
    }
  }
  .videoItem {
    height: auto;
  }
  .videos {
    width: 300px;
    height: 150px;
    margin-left: 130px;
    margin-bottom: 20px;
  }
}
</style>